/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */




 // For scroll animations with CSS
 window.addEventListener('scroll', () => {
   document.body.style.setProperty('--scroll',window.pageYOffset / (document.body.offsetHeight - window.innerHeight));
 }, false);


// var curFix = document.querySelector('button[value="SEK"]');
var curFix = document.querySelector('button[value="SEK"]');
curFix.innerHTML.replace('kr','');


// console.log(curSt);
// function reSek (){
//   curFix = curFix.innerText.replace('kr','');
//   console.log(curFix.innerHTML);
//   }
// reSek();


// ========================================================
//
//    Currency Switch based on hreflang of pages
//
// ========================================================


var lang = document.documentElement.lang.toLowerCase();
var button_type = document.getElementsByClassName('SelectButton Link Link--primary');

var sv_submit = document.querySelectorAll('[value="SEK"]');
var en_submit = document.querySelectorAll('[value="GBP"]');
//
// //console.log(sv_submit[0]);
// //console.log(en_submit[0]);
//
//
// function iniFrame() {
//     if ( window.location !== window.parent.location )
//     {
//
//         // The page is in an iFrames
//         console.log("The page is in an iFrame");
//
//     }
//     else {
//
//         // The page is not in an iFrame
//         if (document.cookie.indexOf("session=") <= 0) {
//
//           if ( lang === "sv" && button_type[0].innerHTML.indexOf('GBP') !== -1 ){
//             //console.log('we got issues, swtch to SEK');
//             sv_submit[0].click();
//           }
//           if ( lang === "en" && button_type[0].innerHTML.indexOf('SEK') !== -1 ){
//             //console.log("switch this to GBP!");
//             en_submit[0].click();
//           }
//
//         }
//           else {
//             document.cookie = "visited";
//             console.log('visited');
//         }
//     }
// }
//
// // Calling iniFrame function
// iniFrame();

//
// //    End of Currency Switch
// // ========================================================





// ========================================================
//
//    Hidden Pages based on site location / language
//
// ========================================================


if ( lang === "en" ){
  // Conditions
  var barometers = document.querySelectorAll('a[href="/pages/underlivsbarometer"]');
  for (var i = 0; i < barometers.length; i++);
  var barometer = barometers[i];
  barometers.forEach(function (barometer){
    barometer.classList.add('hide');
  });

}

if ( lang === "sv" ){
  // Conditions

}


//    End Hidden Pages
// ========================================================


function del_cookie(discount_code) {
    document.cookie = discount_code +
    '=; expires=Thu, 01-Jan-70 00:00:01 GMT;';
}

del_cookie();
